import { useState } from "react";
import { Html } from "@react-three/drei"

const DoorSideLine = ({ radius=0.03, length=1, position=[0, 0, 0], rotation=[0, 0, 0], color='#2F7CBF' }) => {

    return (
        <group position={position} rotation={rotation}>
            <mesh position={[0, 0.05, 0]}>
                <cylinderGeometry attach="geometry" args={[radius, radius, length - 0.2, 6]} />
                <meshBasicMaterial color={color} />
            </mesh>

            <mesh position={[0, length / 2 - 0.1, 0.05]} rotation={[Math.PI / 2, 0, 0]}>
                <cylinderGeometry attach="geometry" args={[0.07, 0.07, 0.01, 64]} />
                <meshBasicMaterial color={color} />
            </mesh>
            <mesh position={[0, length / 2 - 0.1, 0.05]} rotation={[Math.PI / 2, 0, 0]}>
                <cylinderGeometry attach="geometry" args={[0.05, 0.05, 0.015, 64]} />
                <meshBasicMaterial color={'white'} />
            </mesh>

            <mesh position={[0, -length / 2 + 0.2, 0.05]} rotation={[Math.PI / 2, 0, 0]} >
                <cylinderGeometry attach="geometry" args={[0.07, 0.07, 0.01, 64]} />
                <meshBasicMaterial color={color} /> 
            </mesh>
            <mesh position={[0, -length / 2 + 0.2, 0.05]} rotation={[Math.PI / 2, 0, 0]} >
                <cylinderGeometry attach="geometry" args={[0.05, 0.05, 0.015, 64]} />
                <meshBasicMaterial color={'white'} /> 
            </mesh>

            {/* <mesh position={[0, length / 2 - 0.28, 0]}>
                <coneGeometry attach="geometry" args={[radius * 3, 0.4, 6]} />
                <meshBasicMaterial color={"white"} />
            </mesh> */}
            {/* <mesh position={[0, -length / 2 + 0.2, 0]} rotation={[Math.PI, 0, 0]}>
                <coneGeometry attach="geometry" args={[radius * 3, 0.4, 6]} />
                <meshBasicMaterial color={"white"} />
            </mesh> */}
        </group>
    )
}

export default DoorSideLine